<template>
  <v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">
  <div>
    <!-- <v-row>
      <template v-for="(item, i) in items" >
        <v-col>
          <v-hover v-slot:default="{ hover }">
            <v-card
              :class="{ 'on-hover': hover }"
            >
              <v-img
                :src="item.img"
              >
              </v-img>
            </v-card>
          </v-hover>
        </v-col>
      </template>
    </v-row> -->
    <section id="features" class="lighten-3">
        <div class="py-12"></div>
        <h2 class="text-center red--text">联系我们</h2>
        <h2 class="display-2 font-weight-bold  text-center">Doing is better than saying.</h2>
        <h2 class="text-center grey--text">申请试听课程
          亲身体验易途的理念<br> 多年实战开发经验的技术讲师，高品质的教学质量,
          众多企业青睐的人才培育基地</h2>
    </section>
      <div class="py-12"></div>
      <v-form v-model="valid" ref="form">
        <v-container>
          <v-row>
            <v-col
              md="6"
              lg="6"
              xl="6"
              sm="12"
              cols="12"
            >
              <v-text-field
                v-model="formData.name"
                :rules="nameRules"
                :counter="20"
                label="姓名"
                required
                outlined
              ></v-text-field>
            </v-col>

            <v-col
              md="6"
              lg="6"
              xl="6"
              sm="12"
              cols="12"
            >
              <v-text-field
                v-model="formData.contact"
                :rules="emailRules"
                :counter="30"
                label="邮箱/手机号"
                required
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-row>
            <v-col
            >
              <v-textarea
                v-model="formData.msg"
                :rules="msgRules"
                :counter="200"
                autocomplete="描述"
                label="描述"
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
        <div class="text-center">
          <v-btn rounded color="error"
                 min-width="300px"
                 min-height="50px"
                 dar
                 @click="submitForm"
                 :disabled="!valid"
                 k>留言</v-btn>
        </div>
      </v-form>
    <div class="py-12"></div>
      <v-row dense>
        <v-col>
          <v-card>
            <v-card-text>
              <v-icon>mdi-phone</v-icon>
              <p class="display-1 text--primary">
                Phone
              </p>
              <p>+86 0531-66661761 <br/> +86 0531-66661762</p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card>
            <v-card-text>
              <v-icon>mdi-email</v-icon>
              <p class="display-1 text--primary">
                Email
              </p>
              <p>admin@etoak.com <br/> ww@etoak.com</p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card>
            <v-card-text>
              <v-icon>mdi-map-marker</v-icon>
              <p class="display-1 text--primary">
                Address
              </p>
              <p>趵突泉北路6号蓝石中心4层<br/> 培训咨询：(0531)-66661760</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="popDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">{{popTitle}}</v-card-title>
          <v-card-text>{{popText}}</v-card-text>
          <v-card-actions>
            <v-col cols="12">
              <v-row
                :align="alignment"
                :justify="justify">
                <v-btn  outlined elevation="3" color="success" @click="define">确定</v-btn>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</v-responsive>
</template>

<script>
  export default {
    data: () => ({
      popDialog:false,
      popTitle:'',
      popText:'',
      alignment: 'center',
      justify: 'center',
      valid: true,
      formData:{
        name: '',
        contact:'',
        msg: '',
      },
      nameRules: [
        v => (v && (v.length <= 20) || v.length == 0) || '姓名请填写20个字符以内',
      ],
      phoneRules: [
        v => !!v || 'Phone is required',
        v => v.length == 11 || 'Name must be 11 characters',
      ],
      msgRules: [
        v => (v && (v.length <= 200) || v.length == 0) || '请填写200个字符以内',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail/Phone is required',
        v => (v && v.length <= 30) || '电话/邮箱需要1~30个字符',
        // v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
      items: [
        {
          title: 'Rock',
          text: 'Greatest Rock Hits',
          subtext: 'Lose yourself in rock tunes.',
          img: '../../../static/contactus/connectus_bg.png',
        }
      ],
    }),
    mounted(){

    },
    methods:{
      define(){
        this.popDialog = false;
      },
      submitForm(){
        this.$refs.form.validate();
        this.$api.contact.contact(this.formData).then((res)=>{
          this.popText = '我们已经收到您的留言~';
          this.popDialog = true;
          this.$refs.form.reset();
        })
      },

    }
  }
</script>

<style scoped>
  .v-card {
    transition: opacity .4s ease-in-out;
  }

  .v-card:not(.on-hover) {
    opacity: 0.6;
  }

  .show-btns {
    color: rgba(255, 255, 255, 1) !important;
  }
</style>



// WEBPACK FOOTER //
// src/page/contact/contact.vue